import { useCallback } from "react";
import type { BaseEntity } from "../types";

interface UseCardActionsProps<TData extends BaseEntity> {
  data: TData[];
  selectedRows: Set<string>;
  onSelectionChange?: (selectedIds: Set<string>) => void;
  onOpenDetailModal?: (item: TData, ids: string[], index: number) => void;
  onView?: (item: TData) => void;
}

export function useCardActions<TData extends BaseEntity>({
  data,
  selectedRows,
  onSelectionChange,
  onOpenDetailModal,
  onView,
}: UseCardActionsProps<TData>) {
  const handleSelectRow = useCallback(
    (rowId: string) => {
      const newSelected = new Set(selectedRows);
      if (newSelected.has(rowId)) {
        newSelected.delete(rowId);
      } else {
        newSelected.add(rowId);
      }
      onSelectionChange?.(newSelected);
    },
    [selectedRows, onSelectionChange]
  );

  const handleCardClick = useCallback(
    (item: TData, index: number) => {
      console.log("[useCardActions] Card clicked:", {
        itemId: item.id,
        index,
        hasOpenDetailModal: !!onOpenDetailModal,
        hasOnView: !!onView,
        totalItems: data.length,
      });
      
      if (onOpenDetailModal) {
        const ids = data.map((d) => d.id);
        console.log("[useCardActions] Opening detail modal with ids:", ids);
        onOpenDetailModal(item, ids, index);
      } else if (onView) {
        console.log("[useCardActions] Calling onView");
        onView(item);
      }
    },
    [data, onOpenDetailModal, onView]
  );

  return {
    handleSelectRow,
    handleCardClick,
  };
}
